import { ApiClient } from '../client/ApiClient';
import { ApiResponse } from '../types';
import { TrackingOrder } from './types';
import { generateRecaptchaHeaders } from '../utils/recaptcha/generateRecaptchaHeaders';

export type OrderTrackingThemeApiClientConstructorArgs = {
  themeApiBaseUrl: string;
};

export class OrderTrackingThemeApiClient extends ApiClient {
  private readonly _baseUrl: string;

  constructor({ themeApiBaseUrl }: OrderTrackingThemeApiClientConstructorArgs) {
    super();
    this._baseUrl = `${themeApiBaseUrl}/orderTracking`;
  }

  async getTrackingInformation({
    orderNumber,
    phoneNumber,
    recaptchaToken,
    recaptchaAction,
  }: {
    orderNumber: string;
    phoneNumber: string;
    recaptchaToken: string;
    recaptchaAction: string;
  }): Promise<ApiResponse<TrackingOrder>> {
    return await this._fetch<TrackingOrder>({
      path: `${this._baseUrl}/GetTrackingInformation`,
      method: 'POST',
      body: { phoneNumber, orderNumber },
      headers: generateRecaptchaHeaders(recaptchaToken, recaptchaAction),
    });
  }

  async getVerifiedTrackingInformation({
    orderId,
    recaptchaToken,
    recaptchaAction,
  }: {
    orderId: string;
    recaptchaToken: string;
    recaptchaAction: string;
  }): Promise<ApiResponse<TrackingOrder>> {
    return await this._fetch<TrackingOrder>({
      path: `${this._baseUrl}/GetVerifiedTrackingInformation?orderId=${orderId}`,
      method: 'GET',
      headers: generateRecaptchaHeaders(recaptchaToken, recaptchaAction),
    });
  }
}
